@if (person(); as person) {
  @if (showFlag() && person?.national_identification_schema && !flagRight()) {
    <div class="flag flag-{{ person?.national_identification_schema | lowercase }} me-2"></div>
  }
  <span
    [innerHtml]="person?.full_name || '' | highlightText: (highlightText() ? [highlightText()!] : undefined)"></span>
  @if (showDate()) {
    @if (birthDate() || person?.birth_year) {
      <span> (</span>
    }
    <nk-person-birth-date [person]="person"></nk-person-birth-date>
    @if (birthDate() || person?.birth_year) {
      <span>)</span>
    }
  }
  @if (showFlag() && person?.national_identification_schema && flagRight()) {
    <div class="flag flag-{{ person?.national_identification_schema | lowercase }} ms-2"></div>
  }
}
